/** UI strings for the onboarding / account / paywall / settings / cheats module (all copy our own). */
export const en = {
  /* ------------------------------- Landing ------------------------------- */
  'onb.landing.title': 'Learn to draw on real paper',
  'onb.landing.sub': 'Short, step-by-step lessons with Teacher Juno and Scribble.',
  'onb.landing.start': "Let's draw",
  'onb.landing.signin': 'Already have an account? Sign in',

  /* ------------------------------- Common bits ------------------------------- */
  'onb.progress': 'Step {n} of {total}',
  'onb.chooseMore': 'You can choose more than one',
  'onb.continue': 'Continue',

  /* ------------------------------- Grown-up gate ------------------------------- */
  'onb.gate.title': 'Is a grown-up sitting next to you?',
  'onb.gate.yes': 'Yes, a grown-up is here',
  'onb.gate.no': "No, it's just me",
  'onb.consent.title': 'A quick check for grown-ups',
  'onb.consent.body': 'Sketchling is made for kids. We never show ads and only keep what we need to save drawings and progress.',
  'onb.consent.check': "I have a grown-up's permission to use Sketchling",
  'onb.consent.analytics': 'Share anonymous usage info to help us improve the app',
  'onb.consent.analyticsHint': 'Optional. You can change this any time in Settings.',
  'onb.getGrownUp.title': 'Go get a grown-up!',
  'onb.getGrownUp.body': 'Ask a grown-up to sit with you for a minute. They can set things up with you.',
  'onb.getGrownUp.say': 'Hi! Please go and find a grown-up. We will wait right here for you.',
  'onb.getGrownUp.here': 'My grown-up is here',
  'onb.badge.adFree': 'No ads, ever',
  'onb.badge.kids': 'Made for kids',
  'onb.badge.steps': 'Step-by-step lessons',
  'onb.badge.paper': 'Draw on real paper',

  /* ------------------------------- Profile ------------------------------- */
  'onb.who.title': "Who's drawing today?",
  'onb.who.kid': 'Just me',
  'onb.who.together': 'A grown-up and me',
  'onb.age.title': 'How old is the artist?',
  'onb.age.exact': 'Exact age',
  'onb.age.invalid': 'Age must be between 4 and 99',
  'onb.age.years': '{n} years old',
  'onb.age.minus': 'One year younger',
  'onb.age.plus': 'One year older',
  'onb.name.title': "What's your name?",
  'onb.name.hint': 'Teacher Juno will use it to cheer you on.',
  'onb.name.placeholder': 'Your name or nickname',
  'onb.avatar.title': 'Pick your avatar',
  'onb.avatar.build': 'Build your own',
  'onb.avatar.builder': 'Make your character',
  'onb.avatar.use': 'Use this one',
  'onb.builder.face': 'Face',
  'onb.builder.ears': 'Ears',
  'onb.builder.eyes': 'Eyes',
  'onb.builder.brows': 'Brows',
  'onb.builder.mouth': 'Mouth',
  'onb.builder.color': 'Colour',
  'onb.builder.eyeDistance': 'Eye gap',
  'onb.builder.eyeHeight': 'Eye height',
  'onb.builder.mouthHeight': 'Mouth height',
  'onb.signature.title': 'Choose your signature',
  'onb.signature.hint': "You'll sign every drawing with it, just like real artists.",

  /* ------------------------------- Questions ------------------------------- */
  'onb.q.attribution': 'How did you find Sketchling?',
  'onb.q.attribution.friend': 'A friend or family',
  'onb.q.attribution.video': 'A video site',
  'onb.q.attribution.social': 'A social app',
  'onb.q.attribution.school': 'School',
  'onb.q.attribution.store': 'Browsing the app store',
  'onb.q.attribution.other': 'Something else',
  'onb.q.frequency': 'How often do you want to draw each week?',
  'onb.q.frequency.1-2': '1–2 times',
  'onb.q.frequency.3-4': '3–4 times',
  'onb.q.frequency.5+': '5 times or more',
  'onb.q.frequency.unsure': 'Not sure yet',
  'onb.q.materials': 'What do you have to draw with?',
  'onb.q.materials.pencil': 'Pencil and paper',
  'onb.q.materials.lined': 'Only lined paper',
  'onb.q.materials.nothing': 'Nothing right now',
  'onb.q.colours': 'Do you also have colouring tools?',
  'onb.q.colours.pencils': 'Coloured pencils',
  'onb.q.colours.crayons': 'Crayons',
  'onb.q.colours.markers': 'Markers',
  'onb.q.colours.none': 'Not right now',
  'onb.q.why': 'Why do you want to draw?',
  'onb.q.why.fun': 'Just for fun',
  'onb.q.why.better': 'To get better at it',
  'onb.q.why.relax': 'To relax',
  'onb.q.why.family': 'To draw with my family',

  /* ------------------------------- Subjects ------------------------------- */
  'onb.subjects.title': 'What would you love to draw?',
  'onb.subjects.previewTitle': "Here are some things you'll draw in the next few weeks",
  'onb.subjects.previewBody': 'We picked them from your favourites.',

  /* ------------------------------- Calibration ------------------------------- */
  'onb.cal.grab.title': 'Grab a pencil and paper!',
  'onb.cal.grab.body': "Let's warm up with one quick drawing on real paper.",
  'onb.cal.grab.ready': "I'm ready",
  'onb.cal.later': "I'll do it later",
  'onb.cal.circle.title': 'Draw a circle',
  'onb.cal.circle.body': 'Make it as wide as it is tall, and nice and big.',
  'onb.cal.circle.done': 'I drew it!',
  'onb.cal.processing.title': 'Looking at your circle…',
  'onb.cal.processing.lines': 'Finding your lines',
  'onb.cal.processing.proportions': 'Checking the shape',
  'onb.cal.processing.align': 'Lining things up',
  'onb.cal.great.title': 'What a circle!',
  'onb.cal.great.body': "You're a real-paper artist! Your lessons are all set for pencil and paper.",
  'onb.cal.notRound.title': 'Nice try!',
  'onb.cal.notRound.body': 'Go around slowly in one smooth loop, like tracing the edge of a cookie.',
  'onb.cal.unequal.title': 'Almost!',
  'onb.cal.unequal.body': 'Your circle is a bit stretched. Try to make it as wide as it is tall.',
  'onb.cal.tooSmall.title': 'Go bigger!',
  'onb.cal.tooSmall.body': 'Draw your circle big enough to fill most of the page.',
  'onb.cal.noDrawing.title': "We couldn't spot it",
  'onb.cal.noDrawing.body': 'Try a brighter room and press a little harder so your lines are dark.',
  'onb.cal.tryAgain': 'Try again',
  'onb.skip.title': 'Can you tell us why you skipped?',
  'onb.skip.body': 'It helps us make this step better.',
  'onb.skip.noPaper': "I don't have paper right now",
  'onb.skip.camera': "The camera didn't work",
  'onb.skip.screen': 'I prefer drawing on the screen',
  'onb.skip.explore': 'I just want to look around first',
  'onb.skip.other': 'Another reason',

  /* ------------------------------- Value ------------------------------- */
  'onb.proof.kidTitle': "Here's what's waiting for you",
  'onb.proof.adultTitle': 'What Sketchling does for your young artist',
  'onb.proof.kid1.title': 'Real paper, real art',
  'onb.proof.kid1.body': 'Draw with your own pencil, then snap a photo for your journal.',
  'onb.proof.kid2.title': 'Short, fun lessons',
  'onb.proof.kid2.body': 'Teacher Juno shows each line, one step at a time.',
  'onb.proof.kid3.title': 'Sparks and stickers',
  'onb.proof.kid3.body': 'Every drawing earns sparks to unlock new surprises.',
  'onb.proof.kid4.title': 'Your own art journal',
  'onb.proof.kid4.body': 'Keep every drawing and see how much you grow.',
  'onb.proof.adult1.title': 'Skills that build up',
  'onb.proof.adult1.body': 'Paths go from simple shapes to shading, a little each lesson.',
  'onb.proof.adult2.title': 'Screen time that ends on paper',
  'onb.proof.adult2.body': 'The app shows the way; the drawing happens with a real pencil.',
  'onb.proof.adult3.title': 'Safe and ad-free',
  'onb.proof.adult3.body': 'No ads and no chat with strangers. Purchases need a grown-up.',
  'onb.proof.adult4.title': 'Progress you can see',
  'onb.proof.adult4.body': 'The journal keeps every drawing so you can look back together.',

  /* ------------------------------- Reminders ------------------------------- */
  'onb.reminder.title': 'Set a drawing reminder',
  'onb.reminder.body': 'A gentle nudge on your drawing days helps it become a habit.',
  'onb.reminder.days': 'Days',
  'onb.reminder.time': 'Time',
  'onb.reminder.set': 'Set reminder',
  'onb.reminder.notNow': 'Not now',
  'onb.reminder.notifTitle': 'Time to draw!',
  'onb.reminder.notifBody': 'Scribble has a new drawing ready for you.',
  'onb.reminder.saved': 'Reminder saved',
  'onb.day.0': 'S',
  'onb.day.1': 'M',
  'onb.day.2': 'T',
  'onb.day.3': 'W',
  'onb.day.4': 'T',
  'onb.day.5': 'F',
  'onb.day.6': 'S',
  'onb.dayName.0': 'Sunday',
  'onb.dayName.1': 'Monday',
  'onb.dayName.2': 'Tuesday',
  'onb.dayName.3': 'Wednesday',
  'onb.dayName.4': 'Thursday',
  'onb.dayName.5': 'Friday',
  'onb.dayName.6': 'Saturday',

  /* ------------------------------- Second profile ------------------------------- */
  'onb.second.title': 'Does someone else at home like to draw?',
  'onb.second.body': 'Everyone gets their own journal, sparks and progress.',
  'onb.second.sibling': 'Add a brother or sister',
  'onb.second.grownUp': 'Add a grown-up',
  'onb.second.skip': 'Not now',
  'onb.second.formTitle': 'New artist',
  'onb.second.add': 'Add profile',
  'onb.second.added': '{name} can draw too now!',
  'onb.finish': 'All set! Let’s draw',

  /* ------------------------------- Who's drawing ------------------------------- */
  'prof.whoTitle': "Who's drawing?",
  'prof.add': 'Add profile',
  'prof.max': 'You can create up to 5 profiles',
  'prof.familyNote': 'Your plan gives full access to one profile. Family gives full access to up to 5.',
  'prof.seeFamily': 'See Family plan',
  'prof.title': 'Profiles',
  'prof.edit': 'Edit profile',
  'prof.name': 'Name',
  'prof.age': 'Age',
  'prof.avatar': 'Avatar',
  'prof.signature': 'Signature',
  'prof.delete': 'Delete profile',
  'prof.deleteConfirm': "Delete {name}'s profile? Their drawings and progress on this device will be removed.",
  'prof.cantDeletePremium': "The full-access profile can't be deleted while the Individual plan is active.",
  'prof.cantDeleteLast': 'You need at least one profile.',
  'prof.fullAccess': 'Full access',
  'prof.limited': 'Free lessons',
  'prof.makeFull': 'Give full access',
  'prof.madeFull': '{name} now has full access',
  'prof.active': 'Drawing now',
  'prof.switch': 'Switch',
  'prof.count': '{n} of 5 profiles',

  /* ------------------------------- Unlock all ------------------------------- */
  'onb.unlock.coinTitle': 'Your coin is complete!',
  'onb.unlock.tapChest': 'Tap the chest to open it',
  'onb.unlock.title': 'You unlocked all the paths!',
  'onb.unlock.body': 'Now you choose what to draw next.',
  'onb.unlock.choose': 'Choose your path',
  'onb.unlock.playground': 'Explore the playground',
  'onb.unlock.playgroundBody': 'Pick any drawing you like',
  'onb.unlock.coin.outline': 'Outline',
  'onb.unlock.coin.pattern': 'Pattern',
  'onb.unlock.coin.shading': 'Shading',

  /* ------------------------------- Sign in / account ------------------------------- */
  'acc.signin.title': 'Sign in',
  'acc.signup.title': 'Create account',
  'acc.signin.sub': 'Use the email you signed up with. We’ll send you a code.',
  'acc.signin.subPassword': 'Use the email and password of your account.',
  'acc.signup.sub': 'A grown-up’s email keeps drawings and progress safe on every device.',
  'acc.toSignup': 'New here? Create an account',
  'acc.toSignin': 'Have an account? Sign in',
  'acc.email': 'Email',
  'acc.emailPlaceholder': 'grown-up@example.com',
  'acc.emailInvalid': 'Please enter a valid email address',
  'acc.sendCode': 'Send code',
  'acc.codeSent': 'We sent a 4-digit code to {email}',
  'acc.codeLabel': 'Code digit {n}',
  'acc.codeWrong': "That code doesn't match. Please check your email and try again.",
  'acc.codeResend': 'Send a new code',
  'acc.codeResent': 'New code sent',
  'acc.devCode': 'dev code: {code}',
  'acc.otherEmail': 'Use a different email',
  'acc.verify': 'Verify',
  'acc.withPassword': 'Sign in with password',
  'acc.withCode': 'Sign in with an email code',
  'acc.password': 'Password',
  'acc.passwordWrong': "That email and password don't match",
  'acc.signinBtn': 'Sign in',
  'acc.google': 'Continue with Google',
  'acc.apple': 'Continue with Apple',
  'acc.oauthSoon': 'Coming soon. Please use your email for now.',
  'acc.or': 'or',
  'acc.welcomeBack': 'Welcome back!',
  'acc.offline': 'No internet connection. Please try again when you are online.',
  'acc.title': 'Account',
  'acc.signedInAs': 'Signed in as',
  'acc.guest': 'Guest account (not saved yet)',
  'acc.guestBody': 'Add an email so drawings and progress are saved and can move to a new device.',
  'acc.saveAccount': 'Save my account',
  'acc.saved': 'Your account is saved',
  'acc.changeEmail': 'Change email',
  'acc.newEmail': 'New email',
  'acc.emailChanged': 'Email updated',
  'acc.plan': 'Plan',
  'acc.planFree': 'Free',
  'acc.planIndividual': 'Plus',
  'acc.planFamily': 'Family',
  'acc.planIncluded': 'Everything included',
  'acc.planIncludedBody': 'Every lesson, world and feature in this version of the app is open for all profiles.',
  'acc.monthly': 'monthly',
  'acc.yearly': 'yearly',
  'acc.trialUntil': 'Free trial until {date}',
  'acc.renews': 'Renews on {date}',
  'acc.seePlans': 'See plans',
  'acc.restore': 'Restore purchase',
  'acc.restored': 'Purchase restored!',
  'acc.nothingToRestore': 'No purchase found for this account',
  'acc.signout': 'Sign out',
  'acc.signoutConfirm': 'Sign out? Your profiles, progress and drawings stay in your account and come back when you sign in again. This device will start fresh.',
  'acc.signedOut': 'Signed out',
  'acc.delete': 'Delete account',
  'acc.delete1': 'Delete your account?',
  'acc.delete1Body': 'This removes every profile, drawing and purchase link from our servers and this device.',
  'acc.delete2': 'Are you completely sure?',
  'acc.delete2Body': 'This cannot be undone.',
  'acc.deleteYes': 'Yes, delete everything',
  'acc.deleted': 'Account deleted',
  'acc.notSignedIn': 'Not signed in',
  'acc.signinCta': 'Sign in or create account',
  'acc.saveTitle': 'Sign up to save your progress and drawings',
  'acc.saveBody': 'Add a grown-up’s email. We’ll send a 4-digit code to confirm it.',

  /* ------------------------------- Drawer ------------------------------- */
  'acc.drawer.title': 'Account menu',
  'acc.drawer.switch': 'Switch artist',
  'acc.drawer.editProfiles': 'Edit profiles',
  'acc.drawer.settings': 'Settings',
  'acc.drawer.account': 'Account',
  'acc.drawer.language': 'Language',
  'acc.drawer.help': 'Help & contact',
  'acc.drawer.feedback': 'Send feedback',
  'acc.drawer.unlock': 'Unlock everything',
  'acc.drawer.debug': 'Debug menu',
  'acc.feedback.title': 'Tell us what you think',
  'acc.feedback.placeholder': 'Ideas, problems, anything!',
  'acc.feedback.send': 'Send',
  'acc.feedback.thanks': 'Thank you! We read every message.',
  'acc.feedback.failed': 'We couldn’t send it right now. Please try again later.',

  /* ------------------------------- Paywall ------------------------------- */
  'pay.title': 'Unlock every lesson',
  'pay.sub': 'Every path, every playground drawing, and all the surprises.',
  'pay.benefit1': 'All paths and playground drawings',
  'pay.benefit2': 'Sketch Tales, teacher letters and challenges',
  'pay.benefit3': 'Family: full access for up to 5 artists',
  'pay.individual': 'Plus',
  'pay.family': 'Family',
  'pay.monthly': 'Monthly',
  'pay.yearly': 'Yearly',
  'pay.perMonth': '{price} / month',
  'pay.perYear': '{price} / year',
  'pay.yearlyMonthly': 'just {price} / month',
  'pay.bestValue': 'Best value',
  'pay.off': '{n}% OFF',
  'pay.upTo5': 'Up to 5 profiles',
  'pay.oneProfile': '1 full-access profile',
  'pay.onlyMore': 'Only {price} more per month',
  'pay.trialTitle': '{n}-day free trial',
  'pay.today': 'Today',
  'pay.todayBody': 'Unlock everything for free',
  'pay.dayN': 'Day {n}',
  'pay.remindBody': 'We remind you',
  'pay.chargeBody': "You're charged {price}",
  'pay.start': 'Start my free trial',
  'pay.restore': 'Restore purchase',
  'pay.terms': 'Cancel anytime before day {n} and you won’t be charged. By continuing you agree to the Terms of Use and Privacy Policy.',
  'pay.close': 'Close',
  'pay.adult.title': 'Grown-ups only',
  'pay.adult.body': 'Please ask a grown-up to answer:',
  'pay.adult.q': 'What is {a} × {b}?',
  'pay.adult.wrong': 'Not quite. Here is a new one.',
  'pay.purchasing': 'Starting your trial…',
  'pay.failed': "The purchase didn't go through. Nothing was charged.",
  'pay.whoElse': 'Who else likes to draw?',
  'pay.whoElseBody': 'Your plan includes up to 5 profiles.',
  'pay.allDone': "I'm done",
  'pay.celebrate': 'Welcome to the full studio!',
  'pay.celebrateFamily': 'Everyone at home can draw now!',
  'pay.celebrateBody': 'Every path and drawing is open. Have fun!',
  'pay.letsGo': "Let's go",
  'pay.exit.title': 'Still not sure?',
  'pay.exit.body': 'Can you tell us why?',
  'pay.exit.trial': "I'm not sure about the free trial",
  'pay.exit.use': "I don't know if we'll use it",
  'pay.exit.price': 'It costs too much',
  'pay.exit.other': 'I have another subscription',
  'pay.exit.later': 'I want to try the free lessons first',
  'pay.exit.skip': 'Just close',
  'pay.premiumTitle': "You're all unlocked!",
  'pay.premiumBody': 'Your {plan} plan is active.',
  'pay.upgradeFamily': 'Switch to Family',
  'pay.continue': 'Continue',

  /* ------------------------------- Settings ------------------------------- */
  'set.title': 'Settings',
  'set.language': 'Language',
  'set.langSwitched': 'Language switched to English',
  'set.sound': 'Sound',
  'set.sfx': 'Sound effects',
  'set.music': 'Music',
  'set.voice': 'Teacher voice',
  'set.captions': 'Captions',
  'set.motion': 'Reduced motion',
  'set.saver': 'Battery saver',
  'set.saver.auto': 'Auto',
  'set.saver.on': 'On',
  'set.saver.off': 'Off',
  'set.saver.note': 'Battery saver is on: calmer animations, no background music.',
  'set.reminders': 'Drawing reminders',
  'set.privacy': 'Privacy',
  'set.analytics': 'Share anonymous usage info',
  'set.notifications': 'Notifications',
  'set.notifAllow': 'Allow',
  'set.notifOn': 'Allowed',
  'set.notifOff': 'Not allowed in this browser',
  'set.more': 'More',
  'set.help': 'Help & contact',
  'set.privacyPolicy': 'Privacy policy',
  'set.terms': 'Terms of use',
  'set.deleteHelp': 'How to delete an account',
  'set.version': 'Version {v}',
  'set.credits': 'Voices & credits',
  'set.credits.voices': 'The voices of Juno, Scribble, the storyteller and the story friends are pre-rendered on our own computers with open-source speech models: Kokoro-82M (hexgrad), VieNeu-TTS v3 Turbo (with the MOSS audio codec) and VoxCPM2 (OpenBMB), all under the Apache 2.0 licence. The designed voices are synthetic: no real person’s voice is copied.',
  'set.credits.fallback': 'If a line has no recorded clip yet, the device voice reads it instead.',

  /* ------------------------------- Cheats ------------------------------- */
  'dbg.title': 'Debug menu',
  'dbg.tab.cheats': 'Cheats',
  'dbg.tab.actions': 'Actions',
  'dbg.tab.experiments': 'Experiments',
  'dbg.tab.letters': 'Letters',
  'dbg.tab.tales': 'Tales',
  'dbg.tab.challenges': 'Challenges',
  'dbg.tab.analytics': 'Analytics',
  'dbg.unlockAllPaths': 'Unlock all paths',
  'dbg.forcePremium': 'Force premium',
  'dbg.alwaysReview': 'Always show review request',
  'dbg.alwaysOnboarding': 'Always onboarding',
  'dbg.mockPurchase': 'Allow mock purchase (offline)',
  'dbg.showAllItems': 'Show all items',
  'dbg.skipOnboarding': 'Skip onboarding',
  'dbg.autofill': 'Autofill onboarding',
  'dbg.sparks': '+{n} sparks',
  'dbg.completeFtue': 'Complete FTUE',
  'dbg.chestFtue': 'Go to chest (FTUE)',
  'dbg.coinPieces': 'Give coin pieces',
  'dbg.sampler': 'Open item sampler',
  'dbg.dateOffset': 'Date offset: {n} days',
  'dbg.clear': 'Clear app data',
  'dbg.clearConfirm': 'Erase everything on this device?',
  'dbg.restart': 'Restart app',
  'dbg.deliver': 'Deliver pending letters now',
  'dbg.fillEnvelope': 'Fill envelope',
  'dbg.lettersState': 'Envelope {e} · pending {p} · letters {n}',
  'dbg.unlockTales': 'Unlock Sketch Tales now',
  'dbg.talesState': 'Unlocked at: {d}',
  'dbg.creditChallenge': 'Credit current weekly challenge',
  'dbg.challengeState': '{title}: {n} entries',
  'dbg.noChallenge': 'No active challenge',
  'dbg.apply': 'Apply',
  'dbg.applied': 'Config refreshed',
  'dbg.bucketAuto': 'auto',
  'dbg.current': 'current: {b}',
  'dbg.noEvents': 'No events yet',
  'dbg.done': 'Done',
  'dbg.noProfile': 'Create a profile first',
};

export const vi: Record<keyof typeof en, string> = {
  'onb.landing.title': 'Học vẽ trên giấy thật',
  'onb.landing.sub': 'Những bài học ngắn, từng bước một cùng cô Juno và Scribble.',
  'onb.landing.start': 'Cùng vẽ nào',
  'onb.landing.signin': 'Đã có tài khoản? Đăng nhập',

  'onb.progress': 'Bước {n} / {total}',
  'onb.chooseMore': 'Bạn có thể chọn nhiều mục',
  'onb.continue': 'Tiếp tục',

  'onb.gate.title': 'Có người lớn ngồi cạnh bạn không?',
  'onb.gate.yes': 'Có, người lớn đang ở đây',
  'onb.gate.no': 'Không, chỉ có mình con',
  'onb.consent.title': 'Một bước nhỏ dành cho người lớn',
  'onb.consent.body': 'Sketchling được làm cho trẻ em. Chúng tôi không bao giờ hiện quảng cáo và chỉ lưu những gì cần để giữ tranh vẽ và tiến độ.',
  'onb.consent.check': 'Con đã được người lớn cho phép dùng Sketchling',
  'onb.consent.analytics': 'Chia sẻ thông tin sử dụng ẩn danh để giúp chúng tôi cải thiện ứng dụng',
  'onb.consent.analyticsHint': 'Không bắt buộc. Bạn có thể đổi bất cứ lúc nào trong Cài đặt.',
  'onb.getGrownUp.title': 'Đi gọi người lớn nhé!',
  'onb.getGrownUp.body': 'Nhờ một người lớn ngồi cùng con một chút. Họ sẽ cùng con cài đặt.',
  'onb.getGrownUp.say': 'Chào con! Con hãy đi tìm một người lớn nhé. Tụi mình sẽ chờ con ở đây.',
  'onb.getGrownUp.here': 'Người lớn đến rồi',
  'onb.badge.adFree': 'Không bao giờ có quảng cáo',
  'onb.badge.kids': 'Dành riêng cho trẻ em',
  'onb.badge.steps': 'Bài học từng bước',
  'onb.badge.paper': 'Vẽ trên giấy thật',

  'onb.who.title': 'Hôm nay ai sẽ vẽ?',
  'onb.who.kid': 'Chỉ mình con',
  'onb.who.together': 'Con và người lớn',
  'onb.age.title': 'Hoạ sĩ nhí bao nhiêu tuổi?',
  'onb.age.exact': 'Tuổi chính xác',
  'onb.age.invalid': 'Tuổi phải từ 4 đến 99',
  'onb.age.years': '{n} tuổi',
  'onb.age.minus': 'Bớt một tuổi',
  'onb.age.plus': 'Thêm một tuổi',
  'onb.name.title': 'Bạn tên là gì?',
  'onb.name.hint': 'Cô Juno sẽ gọi tên này để cổ vũ bạn.',
  'onb.name.placeholder': 'Tên hoặc biệt danh của bạn',
  'onb.avatar.title': 'Chọn hình đại diện',
  'onb.avatar.build': 'Tự tạo nhân vật',
  'onb.avatar.builder': 'Tạo nhân vật của bạn',
  'onb.avatar.use': 'Chọn nhân vật này',
  'onb.builder.face': 'Khuôn mặt',
  'onb.builder.ears': 'Tai',
  'onb.builder.eyes': 'Mắt',
  'onb.builder.brows': 'Lông mày',
  'onb.builder.mouth': 'Miệng',
  'onb.builder.color': 'Màu sắc',
  'onb.builder.eyeDistance': 'Khoảng cách mắt',
  'onb.builder.eyeHeight': 'Độ cao mắt',
  'onb.builder.mouthHeight': 'Độ cao miệng',
  'onb.signature.title': 'Chọn chữ ký của bạn',
  'onb.signature.hint': 'Bạn sẽ ký tên lên mỗi bức tranh, giống hệt hoạ sĩ thật.',

  'onb.q.attribution': 'Bạn biết đến Sketchling từ đâu?',
  'onb.q.attribution.friend': 'Bạn bè hoặc gia đình',
  'onb.q.attribution.video': 'Một trang video',
  'onb.q.attribution.social': 'Một ứng dụng mạng xã hội',
  'onb.q.attribution.school': 'Trường học',
  'onb.q.attribution.store': 'Tìm trong cửa hàng ứng dụng',
  'onb.q.attribution.other': 'Nơi khác',
  'onb.q.frequency': 'Mỗi tuần bạn muốn vẽ bao nhiêu lần?',
  'onb.q.frequency.1-2': '1–2 lần',
  'onb.q.frequency.3-4': '3–4 lần',
  'onb.q.frequency.5+': '5 lần trở lên',
  'onb.q.frequency.unsure': 'Chưa chắc nữa',
  'onb.q.materials': 'Bạn có gì để vẽ?',
  'onb.q.materials.pencil': 'Bút chì và giấy',
  'onb.q.materials.lined': 'Chỉ có giấy kẻ dòng',
  'onb.q.materials.nothing': 'Bây giờ chưa có gì',
  'onb.q.colours': 'Bạn có thêm đồ tô màu không?',
  'onb.q.colours.pencils': 'Bút chì màu',
  'onb.q.colours.crayons': 'Bút sáp',
  'onb.q.colours.markers': 'Bút dạ màu',
  'onb.q.colours.none': 'Bây giờ chưa có',
  'onb.q.why': 'Vì sao bạn muốn vẽ?',
  'onb.q.why.fun': 'Cho vui thôi',
  'onb.q.why.better': 'Để vẽ giỏi hơn',
  'onb.q.why.relax': 'Để thư giãn',
  'onb.q.why.family': 'Để vẽ cùng gia đình',

  'onb.subjects.title': 'Bạn thích vẽ gì nhất?',
  'onb.subjects.previewTitle': 'Đây là vài thứ bạn sẽ vẽ trong vài tuần tới',
  'onb.subjects.previewBody': 'Tụi mình chọn từ những chủ đề bạn thích.',

  'onb.cal.grab.title': 'Lấy bút chì và giấy nào!',
  'onb.cal.grab.body': 'Mình khởi động bằng một hình vẽ thật nhanh trên giấy thật nhé.',
  'onb.cal.grab.ready': 'Con sẵn sàng rồi',
  'onb.cal.later': 'Để lúc khác',
  'onb.cal.circle.title': 'Vẽ một hình tròn',
  'onb.cal.circle.body': 'Vẽ sao cho chiều ngang bằng chiều cao, và thật to nhé.',
  'onb.cal.circle.done': 'Con vẽ xong rồi!',
  'onb.cal.processing.title': 'Đang xem hình tròn của bạn…',
  'onb.cal.processing.lines': 'Tìm các nét vẽ',
  'onb.cal.processing.proportions': 'Kiểm tra hình dáng',
  'onb.cal.processing.align': 'Căn chỉnh lại',
  'onb.cal.great.title': 'Hình tròn tuyệt quá!',
  'onb.cal.great.body': 'Bạn là hoạ sĩ vẽ trên giấy thật! Các bài học đã sẵn sàng cho bút chì và giấy.',
  'onb.cal.notRound.title': 'Cố gắng tốt lắm!',
  'onb.cal.notRound.body': 'Vẽ chậm một vòng thật mượt, như đang tô theo mép chiếc bánh quy.',
  'onb.cal.unequal.title': 'Gần được rồi!',
  'onb.cal.unequal.body': 'Hình tròn hơi bị dẹt. Thử vẽ chiều ngang bằng chiều cao nhé.',
  'onb.cal.tooSmall.title': 'Vẽ to hơn nào!',
  'onb.cal.tooSmall.body': 'Vẽ hình tròn đủ to để chiếm gần hết trang giấy.',
  'onb.cal.noDrawing.title': 'Tụi mình chưa thấy hình',
  'onb.cal.noDrawing.body': 'Thử chụp ở chỗ sáng hơn và tô nét đậm hơn một chút nhé.',
  'onb.cal.tryAgain': 'Thử lại',
  'onb.skip.title': 'Bạn cho tụi mình biết vì sao bỏ qua nhé?',
  'onb.skip.body': 'Điều này giúp tụi mình làm bước này tốt hơn.',
  'onb.skip.noPaper': 'Bây giờ con không có giấy',
  'onb.skip.camera': 'Máy ảnh không hoạt động',
  'onb.skip.screen': 'Con thích vẽ trên màn hình hơn',
  'onb.skip.explore': 'Con muốn xem qua trước đã',
  'onb.skip.other': 'Lý do khác',

  'onb.proof.kidTitle': 'Những điều đang chờ bạn',
  'onb.proof.adultTitle': 'Sketchling giúp gì cho hoạ sĩ nhí của bạn',
  'onb.proof.kid1.title': 'Giấy thật, tranh thật',
  'onb.proof.kid1.body': 'Vẽ bằng bút chì của bạn, rồi chụp ảnh lưu vào nhật ký.',
  'onb.proof.kid2.title': 'Bài học ngắn và vui',
  'onb.proof.kid2.body': 'Cô Juno chỉ từng nét, từng bước một.',
  'onb.proof.kid3.title': 'Tia sáng và nhãn dán',
  'onb.proof.kid3.body': 'Mỗi bức vẽ được tặng tia sáng để mở khoá bất ngờ mới.',
  'onb.proof.kid4.title': 'Nhật ký tranh của riêng bạn',
  'onb.proof.kid4.body': 'Giữ lại mọi bức vẽ và thấy mình tiến bộ thế nào.',
  'onb.proof.adult1.title': 'Kỹ năng được xây dần',
  'onb.proof.adult1.body': 'Các lộ trình đi từ hình cơ bản đến đổ bóng, mỗi bài một chút.',
  'onb.proof.adult2.title': 'Thời gian màn hình kết thúc trên giấy',
  'onb.proof.adult2.body': 'Ứng dụng chỉ đường; việc vẽ diễn ra bằng bút chì thật.',
  'onb.proof.adult3.title': 'An toàn, không quảng cáo',
  'onb.proof.adult3.body': 'Không quảng cáo, không trò chuyện với người lạ. Mua hàng cần người lớn.',
  'onb.proof.adult4.title': 'Thấy rõ sự tiến bộ',
  'onb.proof.adult4.body': 'Nhật ký giữ mọi bức vẽ để cả nhà cùng xem lại.',

  'onb.reminder.title': 'Đặt lời nhắc vẽ',
  'onb.reminder.body': 'Một lời nhắc nhẹ vào ngày vẽ giúp việc vẽ thành thói quen.',
  'onb.reminder.days': 'Ngày',
  'onb.reminder.time': 'Giờ',
  'onb.reminder.set': 'Đặt lời nhắc',
  'onb.reminder.notNow': 'Để sau',
  'onb.reminder.notifTitle': 'Đến giờ vẽ rồi!',
  'onb.reminder.notifBody': 'Scribble có một bức vẽ mới chờ bạn.',
  'onb.reminder.saved': 'Đã lưu lời nhắc',
  'onb.day.0': 'CN',
  'onb.day.1': 'T2',
  'onb.day.2': 'T3',
  'onb.day.3': 'T4',
  'onb.day.4': 'T5',
  'onb.day.5': 'T6',
  'onb.day.6': 'T7',
  'onb.dayName.0': 'Chủ nhật',
  'onb.dayName.1': 'Thứ hai',
  'onb.dayName.2': 'Thứ ba',
  'onb.dayName.3': 'Thứ tư',
  'onb.dayName.4': 'Thứ năm',
  'onb.dayName.5': 'Thứ sáu',
  'onb.dayName.6': 'Thứ bảy',

  'onb.second.title': 'Ở nhà còn ai thích vẽ nữa không?',
  'onb.second.body': 'Mỗi người có nhật ký, tia sáng và tiến độ riêng.',
  'onb.second.sibling': 'Thêm anh chị em',
  'onb.second.grownUp': 'Thêm người lớn',
  'onb.second.skip': 'Để sau',
  'onb.second.formTitle': 'Hoạ sĩ mới',
  'onb.second.add': 'Thêm hồ sơ',
  'onb.second.added': '{name} cũng vẽ được rồi!',
  'onb.finish': 'Xong rồi! Cùng vẽ nào',

  'prof.whoTitle': 'Ai đang vẽ?',
  'prof.add': 'Thêm hồ sơ',
  'prof.max': 'Bạn có thể tạo tối đa 5 hồ sơ',
  'prof.familyNote': 'Gói của bạn mở toàn bộ cho một hồ sơ. Gói Gia đình mở toàn bộ cho tối đa 5 hồ sơ.',
  'prof.seeFamily': 'Xem gói Gia đình',
  'prof.title': 'Hồ sơ',
  'prof.edit': 'Sửa hồ sơ',
  'prof.name': 'Tên',
  'prof.age': 'Tuổi',
  'prof.avatar': 'Hình đại diện',
  'prof.signature': 'Chữ ký',
  'prof.delete': 'Xoá hồ sơ',
  'prof.deleteConfirm': 'Xoá hồ sơ của {name}? Tranh vẽ và tiến độ của bạn ấy trên thiết bị này sẽ bị xoá.',
  'prof.cantDeletePremium': 'Không thể xoá hồ sơ được mở toàn bộ khi gói Cá nhân đang hoạt động.',
  'prof.cantDeleteLast': 'Cần có ít nhất một hồ sơ.',
  'prof.fullAccess': 'Mở toàn bộ',
  'prof.limited': 'Bài học miễn phí',
  'prof.makeFull': 'Mở toàn bộ cho hồ sơ này',
  'prof.madeFull': '{name} đã được mở toàn bộ',
  'prof.active': 'Đang vẽ',
  'prof.switch': 'Chuyển',
  'prof.count': '{n} / 5 hồ sơ',

  'onb.unlock.coinTitle': 'Đồng xu của bạn đã hoàn chỉnh!',
  'onb.unlock.tapChest': 'Chạm vào rương để mở',
  'onb.unlock.title': 'Bạn đã mở khoá mọi lộ trình!',
  'onb.unlock.body': 'Giờ bạn tự chọn vẽ gì tiếp theo.',
  'onb.unlock.choose': 'Chọn lộ trình của bạn',
  'onb.unlock.playground': 'Khám phá sân chơi',
  'onb.unlock.playgroundBody': 'Chọn bất kỳ bức vẽ nào bạn thích',
  'onb.unlock.coin.outline': 'Đường viền',
  'onb.unlock.coin.pattern': 'Hoạ tiết',
  'onb.unlock.coin.shading': 'Đổ bóng',

  'acc.signin.title': 'Đăng nhập',
  'acc.signup.title': 'Tạo tài khoản',
  'acc.signin.sub': 'Dùng email bạn đã đăng ký. Tụi mình sẽ gửi cho bạn một mã.',
  'acc.signin.subPassword': 'Dùng email và mật khẩu của tài khoản.',
  'acc.signup.sub': 'Email của người lớn giúp giữ tranh vẽ và tiến độ an toàn trên mọi thiết bị.',
  'acc.toSignup': 'Lần đầu đến đây? Tạo tài khoản',
  'acc.toSignin': 'Đã có tài khoản? Đăng nhập',
  'acc.email': 'Email',
  'acc.emailPlaceholder': 'nguoilon@example.com',
  'acc.emailInvalid': 'Vui lòng nhập địa chỉ email hợp lệ',
  'acc.sendCode': 'Gửi mã',
  'acc.codeSent': 'Tụi mình đã gửi mã 4 chữ số đến {email}',
  'acc.codeLabel': 'Chữ số thứ {n} của mã',
  'acc.codeWrong': 'Mã chưa đúng. Vui lòng kiểm tra email và thử lại.',
  'acc.codeResend': 'Gửi mã mới',
  'acc.codeResent': 'Đã gửi mã mới',
  'acc.devCode': 'mã dev: {code}',
  'acc.otherEmail': 'Dùng email khác',
  'acc.verify': 'Xác nhận',
  'acc.withPassword': 'Đăng nhập bằng mật khẩu',
  'acc.withCode': 'Đăng nhập bằng mã qua email',
  'acc.password': 'Mật khẩu',
  'acc.passwordWrong': 'Email và mật khẩu không khớp',
  'acc.signinBtn': 'Đăng nhập',
  'acc.google': 'Tiếp tục với Google',
  'acc.apple': 'Tiếp tục với Apple',
  'acc.oauthSoon': 'Sắp ra mắt. Hiện tại bạn hãy dùng email nhé.',
  'acc.or': 'hoặc',
  'acc.welcomeBack': 'Chào mừng bạn quay lại!',
  'acc.offline': 'Không có kết nối mạng. Vui lòng thử lại khi có mạng.',
  'acc.title': 'Tài khoản',
  'acc.signedInAs': 'Đang đăng nhập với',
  'acc.guest': 'Tài khoản khách (chưa được lưu)',
  'acc.guestBody': 'Thêm email để tranh vẽ và tiến độ được lưu lại và chuyển được sang thiết bị mới.',
  'acc.saveAccount': 'Lưu tài khoản',
  'acc.saved': 'Tài khoản của bạn đã được lưu',
  'acc.changeEmail': 'Đổi email',
  'acc.newEmail': 'Email mới',
  'acc.emailChanged': 'Đã cập nhật email',
  'acc.plan': 'Gói',
  'acc.planFree': 'Miễn phí',
  'acc.planIndividual': 'Plus',
  'acc.planFamily': 'Gia đình',
  'acc.planIncluded': 'Mở toàn bộ',
  'acc.planIncludedBody': 'Mọi bài học, thế giới và tính năng trong phiên bản này đều mở cho tất cả hồ sơ.',
  'acc.monthly': 'theo tháng',
  'acc.yearly': 'theo năm',
  'acc.trialUntil': 'Dùng thử miễn phí đến {date}',
  'acc.renews': 'Gia hạn vào {date}',
  'acc.seePlans': 'Xem các gói',
  'acc.restore': 'Khôi phục giao dịch',
  'acc.restored': 'Đã khôi phục giao dịch!',
  'acc.nothingToRestore': 'Không tìm thấy giao dịch nào cho tài khoản này',
  'acc.signout': 'Đăng xuất',
  'acc.signoutConfirm': 'Đăng xuất? Hồ sơ, tiến độ và tranh vẽ vẫn được lưu trong tài khoản và sẽ quay lại khi bạn đăng nhập lại. Thiết bị này sẽ trở về trạng thái ban đầu.',
  'acc.signedOut': 'Đã đăng xuất',
  'acc.delete': 'Xoá tài khoản',
  'acc.delete1': 'Xoá tài khoản của bạn?',
  'acc.delete1Body': 'Thao tác này xoá mọi hồ sơ, tranh vẽ và liên kết giao dịch khỏi máy chủ và thiết bị này.',
  'acc.delete2': 'Bạn hoàn toàn chắc chắn chứ?',
  'acc.delete2Body': 'Không thể hoàn tác.',
  'acc.deleteYes': 'Có, xoá tất cả',
  'acc.deleted': 'Đã xoá tài khoản',
  'acc.notSignedIn': 'Chưa đăng nhập',
  'acc.signinCta': 'Đăng nhập hoặc tạo tài khoản',
  'acc.saveTitle': 'Đăng ký để lưu tiến độ và tranh vẽ',
  'acc.saveBody': 'Thêm email của người lớn. Tụi mình sẽ gửi mã 4 chữ số để xác nhận.',

  'acc.drawer.title': 'Menu tài khoản',
  'acc.drawer.switch': 'Đổi hoạ sĩ',
  'acc.drawer.editProfiles': 'Sửa hồ sơ',
  'acc.drawer.settings': 'Cài đặt',
  'acc.drawer.account': 'Tài khoản',
  'acc.drawer.language': 'Ngôn ngữ',
  'acc.drawer.help': 'Trợ giúp & liên hệ',
  'acc.drawer.feedback': 'Gửi góp ý',
  'acc.drawer.unlock': 'Mở khoá tất cả',
  'acc.drawer.debug': 'Menu gỡ lỗi',
  'acc.feedback.title': 'Cho tụi mình biết bạn nghĩ gì',
  'acc.feedback.placeholder': 'Ý tưởng, lỗi, bất cứ điều gì!',
  'acc.feedback.send': 'Gửi',
  'acc.feedback.thanks': 'Cảm ơn bạn! Tụi mình đọc mọi tin nhắn.',
  'acc.feedback.failed': 'Chưa gửi được lúc này. Bạn thử lại sau nhé.',

  'pay.title': 'Mở khoá mọi bài học',
  'pay.sub': 'Mọi lộ trình, mọi bức vẽ trong sân chơi và tất cả bất ngờ.',
  'pay.benefit1': 'Mọi lộ trình và bức vẽ trong sân chơi',
  'pay.benefit2': 'Truyện Phác Hoạ, thư của cô giáo và thử thách',
  'pay.benefit3': 'Gia đình: mở toàn bộ cho tối đa 5 hoạ sĩ',
  'pay.individual': 'Plus',
  'pay.family': 'Gia đình',
  'pay.monthly': 'Hằng tháng',
  'pay.yearly': 'Hằng năm',
  'pay.perMonth': '{price} / tháng',
  'pay.perYear': '{price} / năm',
  'pay.yearlyMonthly': 'chỉ {price} / tháng',
  'pay.bestValue': 'Tiết kiệm nhất',
  'pay.off': 'GIẢM {n}%',
  'pay.upTo5': 'Tối đa 5 hồ sơ',
  'pay.oneProfile': '1 hồ sơ mở toàn bộ',
  'pay.onlyMore': 'Chỉ thêm {price} mỗi tháng',
  'pay.trialTitle': 'Dùng thử miễn phí {n} ngày',
  'pay.today': 'Hôm nay',
  'pay.todayBody': 'Mở khoá tất cả miễn phí',
  'pay.dayN': 'Ngày {n}',
  'pay.remindBody': 'Tụi mình nhắc bạn',
  'pay.chargeBody': 'Bạn bị tính phí {price}',
  'pay.start': 'Bắt đầu dùng thử miễn phí',
  'pay.restore': 'Khôi phục giao dịch',
  'pay.terms': 'Huỷ bất cứ lúc nào trước ngày {n} thì bạn sẽ không bị tính phí. Khi tiếp tục, bạn đồng ý với Điều khoản sử dụng và Chính sách quyền riêng tư.',
  'pay.close': 'Đóng',
  'pay.adult.title': 'Chỉ dành cho người lớn',
  'pay.adult.body': 'Hãy nhờ người lớn trả lời:',
  'pay.adult.q': '{a} × {b} bằng bao nhiêu?',
  'pay.adult.wrong': 'Chưa đúng. Đây là câu mới.',
  'pay.purchasing': 'Đang bắt đầu dùng thử…',
  'pay.failed': 'Giao dịch chưa thành công. Bạn chưa bị tính phí.',
  'pay.whoElse': 'Còn ai thích vẽ nữa?',
  'pay.whoElseBody': 'Gói của bạn có tối đa 5 hồ sơ.',
  'pay.allDone': 'Xong rồi',
  'pay.celebrate': 'Chào mừng đến xưởng vẽ đầy đủ!',
  'pay.celebrateFamily': 'Cả nhà đều vẽ được rồi!',
  'pay.celebrateBody': 'Mọi lộ trình và bức vẽ đã mở. Chúc bạn vẽ vui!',
  'pay.letsGo': 'Đi thôi',
  'pay.exit.title': 'Bạn vẫn còn phân vân?',
  'pay.exit.body': 'Bạn cho tụi mình biết lý do nhé?',
  'pay.exit.trial': 'Tôi chưa rõ về bản dùng thử',
  'pay.exit.use': 'Tôi không chắc cả nhà sẽ dùng',
  'pay.exit.price': 'Giá hơi cao',
  'pay.exit.other': 'Tôi đang dùng gói đăng ký khác',
  'pay.exit.later': 'Tôi muốn thử các bài miễn phí trước',
  'pay.exit.skip': 'Chỉ đóng thôi',
  'pay.premiumTitle': 'Bạn đã mở khoá tất cả!',
  'pay.premiumBody': 'Gói {plan} của bạn đang hoạt động.',
  'pay.upgradeFamily': 'Chuyển sang gói Gia đình',
  'pay.continue': 'Tiếp tục',

  'set.title': 'Cài đặt',
  'set.language': 'Ngôn ngữ',
  'set.langSwitched': 'Đã chuyển sang tiếng Việt',
  'set.sound': 'Âm thanh',
  'set.sfx': 'Hiệu ứng âm thanh',
  'set.music': 'Nhạc nền',
  'set.voice': 'Giọng cô giáo',
  'set.captions': 'Phụ đề',
  'set.motion': 'Giảm chuyển động',
  'set.saver': 'Tiết kiệm pin',
  'set.saver.auto': 'Tự động',
  'set.saver.on': 'Bật',
  'set.saver.off': 'Tắt',
  'set.saver.note': 'Đang tiết kiệm pin: hiệu ứng nhẹ hơn, tắt nhạc nền.',
  'set.reminders': 'Lời nhắc vẽ',
  'set.privacy': 'Quyền riêng tư',
  'set.analytics': 'Chia sẻ thông tin sử dụng ẩn danh',
  'set.notifications': 'Thông báo',
  'set.notifAllow': 'Cho phép',
  'set.notifOn': 'Đã cho phép',
  'set.notifOff': 'Trình duyệt này không cho phép',
  'set.more': 'Khác',
  'set.help': 'Trợ giúp & liên hệ',
  'set.privacyPolicy': 'Chính sách quyền riêng tư',
  'set.terms': 'Điều khoản sử dụng',
  'set.deleteHelp': 'Cách xoá tài khoản',
  'set.version': 'Phiên bản {v}',
  'set.credits': 'Giọng đọc & ghi công',
  'set.credits.voices': 'Giọng của Juno, Scribble, người kể chuyện và các bạn trong truyện được tạo sẵn trên máy của chúng tôi bằng các mô hình giọng nói mã nguồn mở: Kokoro-82M (hexgrad), VieNeu-TTS v3 Turbo (kèm bộ mã hoá âm thanh MOSS) và VoxCPM2 (OpenBMB), đều theo giấy phép Apache 2.0. Các giọng được thiết kế là giọng tổng hợp, không sao chép giọng của người thật nào.',
  'set.credits.fallback': 'Câu nào chưa có giọng thu sẵn thì máy sẽ tự đọc bằng giọng của thiết bị.',

  'dbg.title': 'Menu gỡ lỗi',
  'dbg.tab.cheats': 'Mẹo',
  'dbg.tab.actions': 'Thao tác',
  'dbg.tab.experiments': 'Thử nghiệm',
  'dbg.tab.letters': 'Thư',
  'dbg.tab.tales': 'Truyện',
  'dbg.tab.challenges': 'Thử thách',
  'dbg.tab.analytics': 'Phân tích',
  'dbg.unlockAllPaths': 'Mở khoá mọi lộ trình',
  'dbg.forcePremium': 'Bật premium',
  'dbg.alwaysReview': 'Luôn hiện yêu cầu đánh giá',
  'dbg.alwaysOnboarding': 'Luôn chạy giới thiệu',
  'dbg.mockPurchase': 'Cho phép mua giả lập (ngoại tuyến)',
  'dbg.showAllItems': 'Hiện mọi mục',
  'dbg.skipOnboarding': 'Bỏ qua giới thiệu',
  'dbg.autofill': 'Tự điền phần giới thiệu',
  'dbg.sparks': '+{n} tia sáng',
  'dbg.completeFtue': 'Hoàn tất FTUE',
  'dbg.chestFtue': 'Đến rương (FTUE)',
  'dbg.coinPieces': 'Tặng các mảnh xu',
  'dbg.sampler': 'Mở bộ mẫu bài học',
  'dbg.dateOffset': 'Lệch ngày: {n} ngày',
  'dbg.clear': 'Xoá dữ liệu ứng dụng',
  'dbg.clearConfirm': 'Xoá mọi thứ trên thiết bị này?',
  'dbg.restart': 'Khởi động lại',
  'dbg.deliver': 'Giao thư đang chờ ngay',
  'dbg.fillEnvelope': 'Làm đầy phong bì',
  'dbg.lettersState': 'Phong bì {e} · đang chờ {p} · thư {n}',
  'dbg.unlockTales': 'Mở Truyện Phác Hoạ ngay',
  'dbg.talesState': 'Mở khoá lúc: {d}',
  'dbg.creditChallenge': 'Cộng lượt cho thử thách tuần',
  'dbg.challengeState': '{title}: {n} lượt',
  'dbg.noChallenge': 'Không có thử thách nào',
  'dbg.apply': 'Áp dụng',
  'dbg.applied': 'Đã làm mới cấu hình',
  'dbg.bucketAuto': 'tự động',
  'dbg.current': 'hiện tại: {b}',
  'dbg.noEvents': 'Chưa có sự kiện',
  'dbg.done': 'Xong',
  'dbg.noProfile': 'Hãy tạo hồ sơ trước',
};
